function getRoutes() {
	// TODO: set base from environment
	let base = '/';
	if (window.location.hostname.includes('selux.com') ||
		window.location.hostname.includes('www.selux.cdlx.dev')) {
		base = '/configuration2/';
	}
	return [
		{
			name: 'key',
			pattern: base + ':uid'
		},
		{
			name: 'key2',
			pattern: base + '/:uid'
		},
		{
			name: 'prices',
			pattern: base + ':region/:language/prices',
			data: {title: 'Prices'}
		},
		{
			name: 'loginPage',
			pattern: base + ':region/:language/loginPage',
			data: {title: 'Login Page'}
		},
		{
			name: 'home',
			pattern: base + ':region/:language/:family',
			data: {title: 'Home'}
		},
		{
			name: 'media',
			pattern: base + ':region/:language/:family/:media',
			data: {title: 'Media'}
		},
		{
			name: 'configuration',
			pattern: base + ':region/:language/:family/:media/:uid'
		}, {
			name: 'not-found',
			pattern: '*'
		},

	];
}

export default getRoutes;
